const MUITheme = {
  palette: {
    primary: {
      main: '#666666'
    },
    secondary: {
      main: '#666666'
    },
    background: {
      default: '#060607'
    }
  },
  /* Global default prop overrides for Material UI elements */
  props: {
    MuiTooltip: {
      arrow: true
    }
  },
  /*typography: {
      fontFamily: '"muli", sans-serif'
    },*/
  /*zIndex: {
      modal: 99999,
      tooltip: 1500
    },*/
  overrides: {
    MuiPaper: {
      root: {
        marginTop: 4,
        marginBottom: 4
      }
    },
    MuiButton: {
      root: {
        cursor: 'pointer',
        fontWeight: 700,
        fontStyle: 'normal',
        '&$disabled': {
          cursor: 'default',
          color: 'inherit !important',
          /*backgroundColor: 'inherit !important',*/
          opacity: 0.8
        }
      },
      label: {
        justifyContent: 'space-between'
      },
      endIcon: {
        marginRight: 0,
        marginLeft: 0
      }
    },
    MuiCard: {
      root: {
        backgroundColor: '#666666 !important',
        color: '#FFFFFF'
      }
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: '#666666'
      },
      arrow: {
        color: '#666666'
      }
    },
    MuiList: {
      root: {},
      subheader: {}
    }
  }
}

export default MUITheme
